/*
 * This file contains shared declarations regarding state.
 *
 * Both the cells and boards are represented by this enum, (though STATE.TIED
 * is not used for cells).
 */

export let STATE = {
  PLAYING: 0,
  PLAYER_ONE: 1,
  PLAYER_TWO: 2,
  TIED: 3,
};

export function calc_state(state) {
  /*
   * Given an array of cell states, calculate the board state. Or, given an
   * array of board states, calculate the game state.
   */
  let is_empty = false;

  // Multiply the cells in each row/col/diag. Check if the result is PLAYER**3.
  let diag1 = 1
  let diag2 = 1
  for (let i=0; i<3; ++i) {
    diag1 *= state[3*i + i];
    diag2 *= state[3*i + (2-i)];

    let row = 1;
    let col = 1;
    for (let j=0; j<3; ++j) {
      row *= state[3*i + j];
      col *= state[3*j + i];
    }

    // Check if the row or col contains all ones or twos
    if      (row == 1 || col == 1) { return STATE.PLAYER_ONE; }
    else if (row == 8 || col == 8) { return STATE.PLAYER_TWO; }

    // This row or col contains an empty spot
    if (row == 0 || col == 0) { is_empty = true; }
  }
  if (diag1 == 1 || diag2 == 1) {
    return STATE.PLAYER_ONE;
  }
  else if (diag1 == 8 || diag2 == 8) {
    return STATE.PLAYER_TWO;
  }

  // No player has won yet
  if (is_empty) {
    return STATE.PLAYING;
  }
  else {
    return STATE.TIED;
  }
}
